// Constantes para Proyección Comercial

export const MESES = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

// Tipos de cambio fijos para conversión de oportunidades en USD
export const TIPOS_DE_CAMBIO = { Chile: 950, Perú: 3.75 };

// Factores de conversión para pipeline (proyecciones conservadoras)
export const FACTOR_90 = 0.75; // 90% status → reconocer 75%
export const FACTOR_75 = 0.5; // 75% status → reconocer 50%

// Períodos de agregación para la tabla
export const PERIODS = [
  { label: "TOTAL", type: "year", bold: true },
  { label: "Q1", type: "quarter", quarter: 1 },
  { label: "Q2", type: "quarter", quarter: 2 },
  { label: "H1", type: "half", half: 1, bold: true },
  { label: "Q3", type: "quarter", quarter: 3 },
  { label: "Q4", type: "quarter", quarter: 4 },
  { label: "H2", type: "half", half: 2, bold: true },
];

// Helper para obtener rango de meses de un período
export const getPeriodRange = (period) => {
  if (period.type === "quarter") {
    const start = (period.quarter - 1) * 3 + 1;
    return { start, end: start + 2 };
  }
  if (period.type === "half") {
    return { start: period.half === 1 ? 1 : 7, end: period.half === 1 ? 6 : 12 };
  }
  return { start: 1, end: 12 }; // year/TOTAL
};

// Helper para obtener rango desde nombre de período (usado en renderSubtotal)
export const getPeriodRangeByLabel = (periodo) => {
  if (periodo === "Q1") return { start: 1, end: 3 };
  if (periodo === "Q2") return { start: 4, end: 6 };
  if (periodo === "Q3") return { start: 7, end: 9 };
  if (periodo === "Q4") return { start: 10, end: 12 };
  if (periodo === "H1") return { start: 1, end: 6 };
  if (periodo === "H2") return { start: 7, end: 12 };
  if (periodo === "TOTAL") return { start: 1, end: 12 };
  return null;
};
